/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReturnItemDto = {
    /**
     * Sales order item ID to return
     */
    itemId: number;
    /**
     * Reason for returning this specific item
     */
    returnReason: ReturnItemDto.returnReason;
    /**
     * Condition of the returned item
     */
    itemCondition: ReturnItemDto.itemCondition;
    /**
     * Specific notes about this item return
     */
    itemNotes?: string;
    /**
     * Whether to apply restocking fee to this item
     */
    applyRestockingFee: boolean;
    /**
     * Custom restocking fee percentage for this item (0-100)
     */
    restockingFeePercentage?: number;
    /**
     * Custom refund amount for this specific item (overrides automatic calculation). Must not exceed item price.
     */
    customRefundAmount?: number;
};
export namespace ReturnItemDto {
    /**
     * Reason for returning this specific item
     */
    export enum returnReason {
        DEFECTIVE = 'DEFECTIVE',
        WRONG_ITEM = 'WRONG_ITEM',
        NOT_AS_DESCRIBED = 'NOT_AS_DESCRIBED',
        CUSTOMER_CHANGED_MIND = 'CUSTOMER_CHANGED_MIND',
        SIZE_ISSUE = 'SIZE_ISSUE',
        QUALITY_ISSUE = 'QUALITY_ISSUE',
        OTHER = 'OTHER',
    }
    /**
     * Condition of the returned item
     */
    export enum itemCondition {
        NEW = 'NEW',
        LIKE_NEW = 'LIKE_NEW',
        GOOD = 'GOOD',
        FAIR = 'FAIR',
        POOR = 'POOR',
        DAMAGED = 'DAMAGED',
    }
}

